import { FilterQueryParam } from '../search/filter-query-param-util/query-params'
import {
    caravansSearchFields,
    carSearchFields,
    motorhomesSearchFields,
    vansSearchFields,
} from '../search/channel-search-fields'
export enum newKeyType {
    ARRAY,
    STRING,
    NUMBER,
}
interface OptionRequirement {
    newName: FilterQueryParam | string
    type: newKeyType
    dependency?: FilterQueryParam[]
}
type ExistingSearchFields = {
    [key: string | FilterQueryParam]: OptionRequirement
}
export const newKeysMap: ExistingSearchFields = {
    // General
    [FilterQueryParam.make]: {
        newName: FilterQueryParam.make,
        type: newKeyType.ARRAY,
        dependency: [FilterQueryParam.model],
    },
    [FilterQueryParam.model]: {
        newName: FilterQueryParam.model,
        type: newKeyType.ARRAY,
    },
    [FilterQueryParam.postcode]: {
        newName: FilterQueryParam.postcode,
        type: newKeyType.STRING,
    },
    [FilterQueryParam.radius]: {
        newName: carSearchFields.distance.name,
        type: newKeyType.NUMBER,
    },
    [FilterQueryParam.price_to]: {
        newName: carSearchFields.maxPrice.name,
        type: newKeyType.NUMBER,
        dependency: [FilterQueryParam.max_monthly_price, FilterQueryParam.min_monthly_price],
    },
    [FilterQueryParam.price_from]: {
        newName: carSearchFields.minPrice.name,
        type: newKeyType.NUMBER,
        dependency: [FilterQueryParam.max_monthly_price, FilterQueryParam.min_monthly_price],
    },
    [FilterQueryParam.max_monthly_price]: {
        newName: carSearchFields.maxMonthlyPrice.name,
        type: newKeyType.NUMBER,
        dependency: [FilterQueryParam.price_to, FilterQueryParam.price_from],
    },
    [FilterQueryParam.min_monthly_price]: {
        newName: carSearchFields.minMonthlyPrice.name,
        type: newKeyType.NUMBER,
        dependency: [FilterQueryParam.price_to, FilterQueryParam.price_from],
    },
    // Vans
    [FilterQueryParam.body_type]: {
        newName: vansSearchFields.bodyType.name,
        type: newKeyType.ARRAY,
    },
    [FilterQueryParam.supplied_price_from]: {
        newName: vansSearchFields.minSuppliedPrice.name,
        type: newKeyType.NUMBER,
    },
    [FilterQueryParam.supplied_price_to]: {
        newName: vansSearchFields.maxSuppliedPrice.name,
        type: newKeyType.NUMBER,
    },
    //Motorhomes and caravans
    [FilterQueryParam.berth]: {
        newName: caravansSearchFields.berth.name,
        type: newKeyType.ARRAY,
    },
    [FilterQueryParam.year_from]: {
        newName: motorhomesSearchFields.minYear.name,
        type: newKeyType.STRING,
    },
    [FilterQueryParam.style]: {
        newName: caravansSearchFields.style.name,
        type: newKeyType.STRING,
    },
}

export const newKeysMapType = (type: newKeyType, value: string | string[]) => {
    switch (type) {
        case newKeyType.ARRAY:
            return Array.isArray(value) ? value : [value]
        case newKeyType.NUMBER:
            return parseInt((value as string) || '')
        default:
            return value
    }
}
